<template>
  <div class="newPeopleVip">
    <section class="banner">
      <img :src="vipBanner" alt="" />
      <div class="receive" @click="getGift(true)">
        <img src="../../assets/img/newPeopleVipUnreceive.png" alt="" v-if="isReceive" />
        <img src="../../assets/img/newPeopleVipReceive.png" alt="" v-else/>
      </div>
    </section>
    <section class="recommendList">
      <img src="../../assets/img/newPeopleVipTitle.jpg" alt="" />
      <van-list v-if="!isEmpty" v-model="loading" :finished="finished" finished-text="已加载全部商品" @load="onReachBottom">
        <div class="listContainer">
          <div class="listNews" v-for="(item, index) in recommendList" :key="index" @click="goDetail(item.goods_id)">
            <img :src="item.goods_images" alt="" />
            <div class="name"><span>{{item.brand_english}}</span><span>{{item.chengse}}</span></div>
            <div class="price">￥<span>{{item.goods_price}}</span>
              <a v-if="item.original_price">￥{{item.original_price}}</a>
            </div>
            <div class="status" v-if="item.is_self">胖虎自营</div>
          </div>
        </div>
      </van-list>
      <emptyData v-if="isEmpty" message="暂无商品"></emptyData>
    </section>
    <div class="wrap-zhuce" v-if="loginShow">
      <div class="zhuce-con">
        <div class="close" @click="loginShow=false"></div>
        <div class="zhuce">
          <div class="zhuce-top">
            <p>手机号登录</p>
            <input type="number" placeholder="输入手机号" v-model="loginForm.mobile">
            <div class="yzm">
              <input type="text" placeholder="输入验证码" maxLength="6" v-model="loginForm.verificationCode">
              <button class="place" :disabled="disabled" @click="getCode">{{ttext}}</button>
            </div>
          </div>
          <div class="init" @click="login">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import axios from 'axios'
import wxapi from '@/utils/wxApi'
import { validatMobile } from '@/utils/validate'
import { sendVCode, quicklyLogin } from '@/api/login'
import EmptyData from '@/components/business/EmptyData'
import { setCookie, getCookie, BrowserInfo } from '@/utils'

export default {
  data () {
    return {
      page: 1,
      channelId: '',
      loginForm : {
        mobile: '',
        verificationCode: '',
        channel: 2,
        userSource: 33,
        version: ''
      },
      goodsList: [],
      recommendList: [],
      loading: false,
      isEmpty: false,
      finished: false,
      disabled: false,
      isReceive: false,
      loginShow: false,
      vipBanner: '',
      inviteCode: '',
      loginStatus: '',
      ttext: '获取验证码',
    }
  },
  components: { EmptyData },

  created () {
    this.channelId = this.$route.query.channelId
    this.inviteCode = this.$route.query.inviteCode
    this.loginStatus = this.$route.query.loginStatus
    if (this.token) {
      this.getReceive()
    }
    this.getData(true)
    wxapi.wxRegister(this.wxRegCallback)
  },

  computed: {
    token () {
      return this.channelId == 1 ? getCookie('PONHU_WEBAPP_USERTOKEN') : this.$store.getters.token
    },
    browser () {
      return BrowserInfo()
    }
  },

  methods: {
    getData (refresh) {
      axios.post('https://apiv2-app.ponhu.cn/InviteUser/newWelfare', qs.stringify({ invite_code: this.inviteCode, p: this.page })).then(res => {
        let data = res.data
        if (data.code == 200) {
          this.vipBanner = data.list.new_img
          if (data.list.recommendGoods) {
            if (refresh) {
              this.recommendList = data.list.recommendGoods
            } else {
              this.recommendList = [...this.recommendList, ...data.list.recommendGoods]
            }
          } else {
            this.loading = false
            this.finished = true
            if (refresh) {
              this.isEmpty = true
            }
          }
        } else {
          this.$toast(data.msg)
        }
      })
    },
    getReceive() {
      var userId = ''
      if(this.channelId) {
        userId = getCookie('PONHU_WEBAPP_USERID')
      } else {
        userId = getCookie('userid')
      }

      axios.post('https://apiv2-app.ponhu.cn/inviteUser/receiveStatus', qs.stringify({ user_id: userId })).then(res => {
        let data = res.data
        this.isReceive = !data.receiveStatus;
      })
    },
    getGift (type) {
      if (type && this.isReceive) {
        return
      }
      if (this.token) {
        var userId = ''
        if(this.channelId) {
          userId = getCookie('PONHU_WEBAPP_USERID')
        } else {
          userId = getCookie('userid')
        }
        axios.post('https://apiv2-app.ponhu.cn/InviteUser/receiveAll', qs.stringify({ user_id: userId})).then(res => {
          let data = res.data
          if (data.code == 200 || data.code == 102) {// 领取成功
            this.isReceive = true
            if (this.channelId == 1) {
              this.$dialog.confirm({
                title: '提示',
                message: '新人礼包已发放，下单即可使用',
                showConfirmButton: false,
                cancelButtonText: '我知道了'
              }).then(() => {})
            } else {
              this.$dialog.confirm({
                title: '提示',
                message: '新人礼包已发放，下载胖虎奢侈品APP<br/>即可使用',
                cancelButtonText: '以后再说',
                confirmButtonText: '下载APP'
              }).then((res) => {
                location.href = 'http://www.ponhu.cn/shouji.html?plg_nld=1&plg_uin=1&plg_auth=1&plg_usr=1&plg_vkey=1&plg_dev=1'
              })
            }
          } else if (data.code == 100 && type) {// 领取失败/未登录
            this.goLogin()
          } else if (data.code == 101 && type) {
            this.$toast('抱歉, 您已经不是新用户啦')
            // this.isReceive = true
          }
        })
      } else if (type) {
        this.goLogin()
      }
    },
    goLogin () {
      if (this.loginStatus == 'popUp') {
        this.loginShow = true
      } else {
        if (this.channelId == 1) {
          if (this.browser.isIOS) { // Ios
            this.$IOS.Ioslogin(1)
          } else { // Android
            this.$Android.AndroidLogin(1)
          }
        } else {
          window.location.href = process.env.VUE_APP_ROOT_URL + 'index.html#/login?inviteCode=' + this.inviteCode + '&return_url=' + encodeURIComponent(window.location.href)
        }
      }
    },
    // 微信注册
    wxRegCallback () {
      let _this = this
      let option = {
        title: '新人礼分享话术标题：胖虎见面礼 注册即送888元礼包！',
        link: window.location.href,
        desc: '统一摘要：用奢侈品 上胖虎！',
        imgUrl: 'https://res.ponhu.cn/custom/share_logo.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      wxapi.ShareTimeline(option)
      wxapi.ShareAppMessage(option)
    },
    // 加载更多
    onReachBottom () {
      this.page++
      this.loading = true
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    goDetail (id) {
      if (this.channelId == 1) {
        if (this.browser.isIOS) { // Ios
          this.$IOS.IosGoodsDetail(id)
        } else { // Android
          this.$Android.AndroidGoodsDetail(id)
        }
      } else {
        window.location.href = process.env.VUE_APP_ROOT_URL + 'index.html#/goods/' + id
      }
    },
    //获取验证码
    getCode () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let that = this
      let t = 60
      that.ttext = t + '秒后重试'
      that.disabled = true
      var timer = setInterval(function () {
        t--
        if (t > 0) {
          that.ttext = t + '秒后重试'
          that.disabled = true
        } else {
          that.disabled = false
          that.ttext = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      sendVCode({ mobile: this.loginForm.mobile }).then(res => {
        console.log(res)
      }).catch(error => {
        this.$toast(error.errMessage)
      })
    },
    // 登录
    login () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
      }
      if (!this.loginForm.verificationCode) {
        this.$toast('请输入短信验证码')
      }
      quicklyLogin(this.loginForm).then(res => {
        this.$toast('登录成功')
        this.loginShow = false
        setCookie('token',res.userToken,60)
        setCookie('userid',res.userId,60)
        this.$store.dispatch('LoginByUser', res.userToken)
        this.getGift()
      }).catch(error => {
        this.$toast(error.errMessage)
      })
    }
  }
}
</script>

<style scoped>

.van-dialog__header {
  padding-top: 0.5rem !important;
}

.van-dialog {
  width: 7.73rem !important;
  height: auto !important;
  border-radius: 0.16rem !important;
  transform: translate3d(-50%, -70%, 0) !important;
}

.van-button {
  height: 1.15rem !important;
  line-height: 1.15rem !important;
}

.van-dialog__message {
  padding: 0.19rem 0rem 0.32rem !important;
}

.van-dialog__cancel {
  font-size: 0.35rem !important;
}
.van-dialog__confirm {
  font-weight: 500 !important;
  font-size: 0.35rem !important;
  background: #FFD133 !important;
}
</style>


<style lang="less" scoped>

.newPeopleVip {
  width: 1005;
  min-height: 100vh;
  background: #F3F3F3;

  img {
    width: 100%;
    pointer-events: none;
  }

  .banner {
    width: 100%;
    position: relative;
  }

  .receive {
    position: absolute;
    bottom: 1.53rem;
    left: calc(50% - 2.61rem);
    width: 5.22rem;
    height: 1.68rem;

    img {
      height: 100%;
    }
  }

  .recommendList {
    width: 100%;

    .listContainer {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 0 0.34rem;
      box-sizing: border-box;

      .listNews {
        width: 4.55rem;
        height: 6.76rem;
        background: #fff;
        overflow: hidden;
        border-radius: 0.08rem;
        margin-bottom: 0.24rem;

        img {
          width: 4.55rem;
          height: 4.55rem;
        }

        .name {
          color: #333;
          font-size: 0.32rem;
          margin-top: 0.32rem;
          padding: 0 0.32rem;
          height: 0.36rem;
          // overflow: hidden;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .price {
          color:#DA3232;
          font-size: 0.32rem;
          margin: 0.16rem 0;
          padding: 0 0.24rem;
          height: 0.48rem;
          font-weight: bold;
          display: flex;
          align-items: center;

          span {
            font-size: 0.43rem;
          }
          
          a {
            color:#222;
            font-size: 0.26rem;
            font-weight: normal;
            margin-left: 0.15rem;
            text-decoration: line-through;
          }
        }

        .status {
          color:#222;
          width: 1.2rem;
          height: 0.4rem;
          text-align: center;
          border-radius: 2px;
          font-size: 0.27rem;
          line-height: 0.4rem;
          background: #FFD133;
          margin-left: 0.24rem;
        }
      }

      .listNews:nth-child(2n) {
        margin-left: 0.21rem;
      }
    }
  }
  //登录
  .wrap-zhuce {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    .zhuce-con {
      width: 5.82rem;
      height: 5.88rem;
      position: absolute;
      top: 19.5%;
      left: 50%;
      transform: translateX(-50%);
      .close {
        width: 0.57rem;
        height: 0.81rem;
        background: url('../../assets/img/close.png');
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 0;
      }
      .zhuce {
        width: 5.82rem;
        height: 5.07rem;
        background: white;
        border-radius: 0.12rem;
        position: absolute;
        bottom: 0;
        left: 0;
        .zhuce-top {
          width: 5.13rem;
          height: 3.16rem;
          margin: 0.44rem auto;
          p {
            font-size: 0.32rem;
            font-weight: 800;
            color: #333333;
            line-height: 0.4rem;
            text-align: center;
          }
          p:nth-child(2) {
            font-size: 0.28rem;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 0.4rem;
            margin-top: 0.19rem;
          }
          input {
            width: 4.9rem;
            height: 0.89rem;
            text-align: left;
            background: #f7f7f7;
            font-size: 0.28rem;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            outline: none;
            border: none;
            padding: 0 0 0 0.25rem;
            border-radius: 0.12rem;
            position: absolute;
            top: 1.3rem;
          }
          .yzm {
            width: 4.9rem;
            height: 0.89rem;
            border-radius: 0.12rem;
            color: rgba(153, 153, 153, 1);
            font-weight: 400;
            outline: none;
            border: none;
            position: absolute;
            top: 1.4rem;
            input {
              width: 2.56rem;
              height: 0.89rem;
              border-radius: 0.12rem;
              padding: 0 0 0 0.25rem;
              margin-top: 0;
            }
            .place {
              width: 2rem;
              height: 0.89rem;
              padding: 0;
              border-radius: 0.12rem;
              border: 1px solid #ffd133;
              color: #ffd133;
              background-color: #ffffff;
              float: right;
              text-align: center;
              line-height: 0.89rem;
              font-size: 0.28rem;
              position: absolute;
              left: 3.1rem;
              top: 1.3rem;
            }
          }
        }
        .init {
          width: 100%;
          height: 0.88rem;
          background: #ffd133;
          color: #282828;
          font-size: 0.28rem;
          line-height: 0.88rem;
          color: rgba(40, 40, 40, 1);
          text-align: center;
          position: absolute;
          bottom: 0;
          border-bottom-left-radius: 0.12rem;
          border-bottom-right-radius: 0.12rem;
        }
      }
    }
  }
}
</style>
